import React from 'react';
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';
import Splash from './splash/Splash';
import Avatar from './avatar/Avatar';
import Intro from './intro/Intro';
import Lobby from './lobby/Lobby';
import Login from './login/Login';
import Mode from './mode/Mode';
import Questionnaire from './questionnaire/Questionnaire';
import Score from './score/Score';
import Group from './group/Group';

interface GameRouterProps {}

const GameRouter = (props: GameRouterProps) => {
    return (
        <Router>
            <Switch>
                <Route path={`${process.env.PUBLIC_URL}/`} component={Splash} exact></Route>
                <Route path={`${process.env.PUBLIC_URL}/login`} component={Login} exact></Route>
                <Route path={`${process.env.PUBLIC_URL}/lobby`} component={Lobby} exact></Route>
                <Route path={`${process.env.PUBLIC_URL}/avatar`} component={Avatar} exact></Route>
                <Route path={`${process.env.PUBLIC_URL}/mode/:worldId`} component={Mode} exact></Route>
                <Route path={`${process.env.PUBLIC_URL}/intro/:worldId`} component={Intro} exact></Route>
                <Route
                    path={`${process.env.PUBLIC_URL}/questionnaire/:worldId`}
                    component={Questionnaire}
                    exact
                ></Route>
                <Route path={`${process.env.PUBLIC_URL}/group/:worldId/:groupId`} component={Group} exact></Route>
                <Route path={`${process.env.PUBLIC_URL}/score/:worldId`} component={Score} exact></Route>
                <Route path={`${process.env.PUBLIC_URL}/score/:worldId/:groupId`} component={Score} exact></Route>
                <Route path={`${process.env.PUBLIC_URL}/review/:worldId`} component={Questionnaire} exact></Route>
            </Switch>
        </Router>
    );
};

export default GameRouter;
